module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/02e99f8cbc9069e1cd1727ca1a243b70.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Legend/Legend2.svg
// module id = n/tl
// module chunks = 1